import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {HttpClient} from "@angular/common/http";

@Component({
  selector: 'app-recall-form',
  templateUrl: './recall-form.component.html',
  styleUrls: ['./recall-form.component.scss']
})
export class RecallFormComponent implements OnInit {
  tel = '';
  name = '';
  formStep =1;
  entryId = '';
  name2;
  tel2;
  @ViewChild('input_tel', {static: false}) telValue:ElementRef;
  @ViewChild('input_name', {static: false}) nameValue:ElementRef;

  @Input('heading') heading = 'Нужно вступить в СРО? Мы перезвоним';

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
  }
  submit(){
    this.name2= this.nameValue.nativeElement.value;
    this.tel2 = this.telValue.nativeElement.value;
    this.http.post('https://fsetan.ru/api/feedback/',   {
      name: this.nameValue.nativeElement.value,
      email: '',
      phone: this.telValue.nativeElement.value,
      message: 'Обратная связь Фсетан'
    }).subscribe(response => {
      this.entryId = response['feedback_number'];
      if (window['Comagic'] && window['Comagic'].addOfflineRequest) {
        window['Comagic'].addOfflineRequest({
          name: this.name2,
          email: '',
          phone: this.tel2,
          message: 'Обратная связь Фсетан',
        });
      }
    });
  }
}
